/* =========================================================================
   HulkApps Product Options — PLAQUE Customization
   Textarea-based, dynamic per-quantity fields, NO color logic.
   Standalone file — safe to load alongside (or without) the Engraving script.
   ========================================================================= */

/* ---------------- CONFIG ---------------- */
// Adjust these to match your real DOM / product options
const PLAQUE_BASE_LABEL_PREFIX = "Text";        // aria-label of the ORIGINAL "for all" field, e.g. "Text 1"
const PLAQUE_LINE_LABEL_PREFIX = "Text"; // aria-label prefix used for each ADDED per-unit field, e.g. "Plaque Line 1"
const PLAQUE_LINES_PER_UNIT = 1;                // one textarea per plaque unit
const PLAQUE_PID = "REPLACE_WITH_PLAQUE_PRODUCT_OPTION_ID";
const PLAQUE_MAX_LENGTH = 120;                  // textareas can hold more than a 16-char engraving line

/* ---------------- BOOTSTRAP ---------------- */
window.addEventListener("load", () => {
	const polling = setInterval(() => {
		const plaqueOption = document.querySelector(".hulkapps_option.rb_render > div[aria-label='Plaque'] + div input[type='hidden']");

		// console.log('plaqueOption-->', plaqueOption);

		if (plaqueOption) {
			clearInterval(polling);

			const form = plaqueOption.closest("form");
			const optionSet = form.querySelector(".hulkapps_option_set");
			const quantityInput = form.querySelector("input[name='quantity']");

            initPlaque(plaqueOption, optionSet, quantityInput);

			setTimeout(() => updatePrices(quantityInput.value), 50);
		}
	}, 100);

	setTimeout(() => clearInterval(polling), 20000);

	document.querySelectorAll(".variant-input-wrap .variant-input input").forEach(input => {
		input.addEventListener("change", e => setTimeout(() => updatePrices(document.querySelector("input[name='quantity']").value), 50));
	});
});

/* =========================================================================
   PLAQUE
   ========================================================================= */
function initPlaque(plaqueOption, optionSet, quantityInput) {
	const observer = new MutationObserver(() => {
		toggleGroup({
			hiddenInput: plaqueOption,
			container: document.querySelector(".plaque_container"),
			repeatBtns: document.querySelectorAll(".plaque_repeat"),
			title: document.querySelector(".plaque_title"),
			singleLabel: "Plaque for All",
			multiLabelPrefix: "Plaque 1 of 1"
		});

		if (plaqueOption.getAttribute("value").includes("Different")) {
			syncPlaqueGroups(plaqueOption, document.querySelector(".plaque_container"), quantityInput.value);
		}
	});
	observer.observe(plaqueOption, { attributes: true, attributeFilter: ["value"] });

	const plaqueContainer = document.createElement("div");
	plaqueContainer.className = "plaque_container";
	optionSet.appendChild(plaqueContainer);

	quantityInput.addEventListener("change", e => {
        if (plaqueOption.getAttribute("value").includes("Different")) {
            syncPlaqueGroups(plaqueOption, plaqueContainer, e.target.value);
            updatePrices(e.target.value);   
        }
	});

	// Base "Text N" field(s) (for-all state) + Repeat buttons — no color/preview styling.
	// NOTE: unlike Engraving's "Line N" fields, which are plain text inputs (.tb_render),
	// the Plaque field is a native <textarea> — HulkApps renders that as .ta_render, not
	// .tb_render. We deliberately don't require a specific render class here so this keeps
	// working even if the theme's exact render class differs.
	const plaqueLineList = optionSet.querySelectorAll(`.hulkapps_option:has(div[aria-label^='${PLAQUE_BASE_LABEL_PREFIX}'])`);
	if (plaqueLineList.length === 0) {
		console.warn(`Plaque script: no base field found matching aria-label^='${PLAQUE_BASE_LABEL_PREFIX}'. Default title and Repeat button will not appear — update PLAQUE_BASE_LABEL_PREFIX to match your theme's actual aria-label.`);
	}
	plaqueLineList.forEach((element, index) => {
		if (index === 0) {
			const newOptionTitle = document.createElement("h2");
			newOptionTitle.textContent = "";
			newOptionTitle.className = "plaque_title";
			element.parentElement.insertBefore(newOptionTitle, element);
		}

		// const newPlaquePreview = document.createElement("div");
		// newPlaquePreview.className = `plaque_preview plaque_preview_${index + 1}`;
		// element.appendChild(newPlaquePreview);

		// Convert existing text input to a textarea if one isn't already present in the markup
		let field = element.querySelector("textarea");
		if (!field) {
			const existingInput = element.querySelector("input[type='text']");
			field = buildTextarea(existingInput);
		}

		// field.addEventListener("input", e => {
		// 	newPlaquePreview.textContent = e.target.value;
		// });

		const newRepeatBtn = document.createElement("button");
		newRepeatBtn.textContent = "Repeat";
		newRepeatBtn.className = "plaque_repeat";
		newRepeatBtn.setAttribute("data-active", "false");
        newRepeatBtn.style.display = "none";

		const valueContainer = element.querySelector(".hulkapps_option_value") || field.parentElement || element;
		valueContainer.appendChild(newRepeatBtn);

		newRepeatBtn.addEventListener("click", e => {
			e.preventDefault();

			const val = field.value;
			const isActive = e.target.getAttribute("data-active") === "true";
			const nextVal = isActive ? "" : val;

			document.querySelectorAll(`.hulkapps_option.plaque_different > .hulkapps_option_name[aria-label="${PLAQUE_LINE_LABEL_PREFIX} ${index + 1}"] + div textarea`).forEach(ta => {
            ta.value = nextVal;
                ta.dispatchEvent(new Event("change", {
                    bubbles: true
                }));
            });
            
			document.querySelectorAll(`.hulkapps_option.plaque_different > .hulkapps_option_name[aria-label="${PLAQUE_LINE_LABEL_PREFIX} ${index + 1}"] + div + div`).forEach(preview => {
				preview.textContent = nextVal;
			});

			e.target.setAttribute("data-active", isActive ? "false" : "true");
		});
	});
}

// Recomputes plaque groups from scratch every time: counts what currently exists in the DOM,
// adds/removes groups to match the target quantity, then renumbers every title in one pass.
// This avoids any drift/skipped-title bugs from incremental diffing across repeated changes.
function syncPlaqueGroups(plaqueOption, container, quantityValue) {
	const desiredQty = parseInt(quantityValue, 10) || 1;
	const currentGenerated = container.querySelectorAll(".plaque_different").length / PLAQUE_LINES_PER_UNIT;
	const currentTotal = 1 + currentGenerated; // +1 for the base "Text 1" group

	if (desiredQty > currentTotal) {
		createNewPlaqueOptions(container, desiredQty - currentTotal, desiredQty, currentTotal);
	} else if (desiredQty < currentTotal) {
		deleteExistingPlaqueOptions(container, currentTotal - desiredQty);
	}

	const isDifferent = plaqueOption.getAttribute("value").includes("Different");
    console.log("isDifferent",isDifferent);
	document.querySelectorAll(".plaque_title").forEach((title, i) => {
		title.textContent = isDifferent ? `Plaque ${i + 1} of ${desiredQty}` : "Plaque for All";
		title.style.display = "block";
	});
}

// Swaps a text input for a textarea in place, preserving classes/attrs relevant to the app
function buildTextarea(existingInput) {
	const textarea = document.createElement("textarea");
	textarea.className = existingInput ? existingInput.className : "hulkapps_option_child hulk_po_other_options hulkapps_full_width price-change";
	textarea.setAttribute("data-parent", "hulkapps_product_options");
	textarea.setAttribute("data-pid", PLAQUE_PID);
	textarea.setAttribute("data-price", "0.00");
	textarea.maxLength = PLAQUE_MAX_LENGTH;
	textarea.rows = 3;

	if (existingInput) {
		existingInput.replaceWith(textarea);
	}
	return textarea;
}

function createNewPlaqueOptions(optionSet, num, quantity, len) {
	for (let i = 0; i < num; i++) {
		for (let j = 0; j < PLAQUE_LINES_PER_UNIT; j++) {
			const wrapper = document.createElement("div");
			wrapper.className = "hulkapps_option ta_render full_width plaque_different";

			if (j === 0) {
				const newOptionTitle = document.createElement("h2");
				newOptionTitle.textContent = `Plaque ${len + i + 1} of ${quantity}`;
				newOptionTitle.className = "plaque_title";
				newOptionTitle.style.display = "block";
				wrapper.appendChild(newOptionTitle);
			}

			const labelDiv = document.createElement("div");
			labelDiv.className = "hulkapps_option_name";
			labelDiv.setAttribute("aria-label", `${PLAQUE_LINE_LABEL_PREFIX} ${j + 1}`);
			labelDiv.setAttribute("tabindex", "0");
			labelDiv.setAttribute("aria-required", "false");

			const labelInner = document.createElement("div");
			labelInner.textContent = `${PLAQUE_LINE_LABEL_PREFIX} ${j + 1}`;
			labelDiv.appendChild(labelInner);

			const valueDiv = document.createElement("div");
			valueDiv.className = "hulkapps_option_value";

			const textarea = document.createElement("textarea");
			textarea.className = "hulkapps_option_child hulk_po_other_options hulkapps_full_width price-change";
			textarea.setAttribute("data-parent", "hulkapps_product_options");
			textarea.setAttribute("data-pid", PLAQUE_PID);
			textarea.setAttribute("data-price", "0.00");
			textarea.maxLength = PLAQUE_MAX_LENGTH;
			textarea.rows = 3;

			const hidden1 = document.createElement("input");
			hidden1.type = "hidden";
			hidden1.name = `properties[${PLAQUE_LINE_LABEL_PREFIX} ${j + 1}_${len + i + 1}]`;
			hidden1.className = "tb_property_val other_options_prop_val";

			const hidden2 = document.createElement("input");
			hidden2.type = "hidden";
			hidden2.value = String(PLAQUE_MAX_LENGTH);
			hidden2.className = "character_count";

			const charCount = document.createElement("div");
			charCount.id = `plaque_char_count_${len + i + 1}_${j + 1}`;
			charCount.textContent = `${PLAQUE_MAX_LENGTH} Characters remaining`;

			// Plain-text preview, no color styling applied
			const newPlaquePreview = document.createElement("div");
			newPlaquePreview.className = `plaque_preview plaque_preview_${j + 1}`;

			textarea.addEventListener("input", e => {
				newPlaquePreview.textContent = e.target.value;
				const remaining = PLAQUE_MAX_LENGTH - e.target.value.length;
				charCount.textContent = `${remaining} Characters remaining`;
			});

			valueDiv.appendChild(textarea);
			valueDiv.appendChild(hidden1);
			valueDiv.appendChild(hidden2);
			valueDiv.appendChild(charCount);

			wrapper.appendChild(labelDiv);
			wrapper.appendChild(valueDiv);
			// wrapper.appendChild(newPlaquePreview);

			optionSet.appendChild(wrapper);
		}
	}
}

function deleteExistingPlaqueOptions(optionSet, num) {
	const plaqueDifferentList = optionSet.querySelectorAll(".plaque_different");
	const toRemove = num * PLAQUE_LINES_PER_UNIT;

	for (let i = 0; i < toRemove; i++) {
		const last = plaqueDifferentList[plaqueDifferentList.length - 1 - i];
		if (last) last.remove();
	}
}

/* =========================================================================
   SHARED HELPERS
   ========================================================================= */

// Show/hide toggle for the "Different"/"For All" state
function toggleGroup({ hiddenInput, container, repeatBtns, title, singleLabel, multiLabelPrefix }) {
	if (!hiddenInput || !container || !title) return;

	if (hiddenInput.getAttribute("value").includes("Different")) {
		container.style.display = "block";
		repeatBtns.forEach(rpt => rpt.style.display = "block");
		title.textContent = multiLabelPrefix;
		title.style.display = "block";
	} else {
		container.style.display = "none";
		repeatBtns.forEach(rpt => rpt.style.display = "none");
		title.textContent = singleLabel;
		title.style.display = "block";
	}
}

function getDiscountedPrice(quantity) {
	const tierElements = document.querySelectorAll(".variant-input-wrap .variant-input:has(input:checked) + div > div");

	for (const el of tierElements) {
		const lines = el.innerText.trim().split("\n").map(t => t.trim());
		if (lines.length < 2) continue;

		const rangeText = lines[0]; // e.g. "2-4" or "100+"
		const priceText = lines[1]; // e.g. "$9.50"
		const price = parseFloat(priceText.replace("$", ""));

		let min, max;
		if (rangeText.includes("-")) {
			const [low, high] = rangeText.split("-").map(Number);
			min = low;
			max = high;
		} else if (rangeText.includes("+")) {
			min = parseInt(rangeText);
			max = Infinity;
		} else {
			min = parseInt(rangeText);
			max = min;
		}

		if (quantity >= min && quantity <= max) {
			return price * quantity;
		}
	}

	return null;
}

function updatePrices(quantity) {
	const price = getDiscountedPrice(quantity);

	const atcBtn = document.querySelector(".add-to-cart.hulkapps_submit_cart span");
	const money = atcBtn.querySelector("span.money");
	if (money) {
		money.textContent = formatPrice(price);
	} else {
		atcBtn.innerHTML += `<span>●</span><span class="money">${formatPrice(price)}</span>`;
	}
}

function formatPrice(price) {
	return price.toLocaleString(Shopify.locale + '-' + Shopify.country, {
		style: 'currency',
		currency: Shopify.currency.active
	}).replace(/^.*\$/, "$");
}